/* Resources */
/* Helpers */
import { citiesOrder } from "../../../helper/orders";
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import SearchBox from "../../../components/common/SearchBox";
import usePager from "../../../hooks/usePager";
import {getCityList} from "../../../api/admin/funedataReq";
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
import {useEffect} from "react";


export default function Cities() {
    const sources = "fa fa-city";
    const { auth } = useAuth();
    const { dataList, setDataList } = useData();
    const token = auth.token;
    const {
        currentPage, setCurrentPage,
        itemsPerPage,
        setTotalPages, totalPages }
    = usePager();

    const apiCityList = async () => {
        const response = await getCityList(token, currentPage, itemsPerPage)
        setDataList(response)
    };

    useEffect(() => {
        apiCityList()
    }, [ setTotalPages, setCurrentPage, currentPage, itemsPerPage, totalPages, ]);

    const headers = [
        { label :"Code postal", key : "zipcode" },
        { label: "Ville", key : "city" },
        { label :"Département", key : "county" },
    ];

    return (
        <main className="admin">
            <Header parent="Administration" location="Villes" />
            <div className="flex">
                <SearchBox location="Villes" headers={headers} filename="Villes" />
                <div className="dashboard">
                    <Icon source={ sources } color="blue" span="Liste des villes"/>
                    <Dashboard location="Villes" dataObject={ dataList || [] } order={ citiesOrder } />
                </div>
            </div>
        </main>
    )
}